import { useQuery } from '@tanstack/react-query';
import { fetchUser } from '@/api/user';
import { APIError } from '@/components/api-common';

export const useUserQuery = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: fetchUser,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error) => {
      if (error instanceof APIError) {
        if (error.code == 115) {
          return false;
        }
      }
      // Don't retry on auth errors (401, 403, code 115)
      // Retry up to 2 times for other errors
      return failureCount < 2;
    },
  });
};
